import React from 'react';
import { IIconProps } from '../../interfaces';
const XIcon = (props: IIconProps) => {
  /*w13 h16*/
  return (
    <svg className="inline-block" width={props.width} height={props.height} viewBox="0 0 24 24" fill="none" style={props.style}>
        <path
            d="M18.244 2.25H21.552L14.325 10.51L22.827 21.75H16.17L10.956 14.933L4.99 21.75H1.68L9.41 12.915L1.254 2.25H8.08L12.793 8.481L18.244 2.25ZM17.083 19.77H18.916L7.084 4.126H5.117L17.083 19.77Z"
            fill={props.color ? props.color : 'black'}></path>
    </svg>
  )
};

export default XIcon;